import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { CssBaseline, Box } from "@mui/material";

import { HomePage } from "./pages/HomePage.tsx";
import { PrivacyPage } from "./pages/PrivacyPage.tsx";
import { TermsPage } from "./pages/TermsPage.tsx";
import { AdminDashboardPage } from "./pages/AdminDashboardPage.tsx";
import { AdminDogApplicationsPage } from "./pages/AdminDogApplicationsPage.tsx";
import { CustomerPortalPage } from "./pages/CustomerPortalPage.tsx";
import { MyReservationsPage } from "./pages/MyReservationsPage.tsx";
import { MyDogsPage } from "./pages/MyDogsPage.tsx";
import { NewDogApplicationPage } from "./pages/NewDogApplicationPage.tsx";
import { NewReservationPage } from "./pages/NewReservationPage.tsx";
import { LoginPage } from "./pages/LoginPage.tsx";
import { AdminDogsPage } from "./pages/AdminDogsPage.tsx";
import { AdminCustomersPage } from "./pages/AdminCustomersPage.tsx";
import { AdminAgendaPage } from "./pages/AdminAgendaPage.tsx";
import { AccountActivationPage } from "./pages/AccountActivationPage.tsx";

import { AuthProvider } from "./auth/AuthContext.tsx";
import { ProtectedRoute } from "./auth/ProtectedRoute.tsx";

import { Layout } from "./components/Layout.tsx";
import { BookingDialog } from "./components/BookingDialog.tsx";
import { ReviewPage } from "./pages/ReviewPage.tsx";
import emailjs from "@emailjs/browser";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import {
  ThemeProvider,
  useThemeContext
} from "./contexts/ThemeContext.tsx";
import { getTheme } from "./theme.ts";

const ThemedApp = () => {
  const { mode } = useThemeContext();
  const theme = getTheme(mode);

  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    document.body.style.backgroundColor =
      theme.palette.background.default;
  }, [mode, theme.palette.background.default]);

  return (
    <MuiThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "background.default"
        }}
      >
        <Router>
          <CssBaseline />

          <Routes>
            <Route
              path="/"
              element={
                <Layout
                  onOpenBookingDialog={() =>
                    setOpenDialog(true)
                  }
                />
              }
            >
              <Route
                index
                element={
                  <HomePage
                    onOpenBookingDialog={() =>
                      setOpenDialog(true)
                    }
                  />
                }
              />

              <Route
                path="algemene-voorwaarden"
                element={<TermsPage />}
              />

              <Route
                path="privacy"
                element={<PrivacyPage />}
              />

              <Route
                path="inloggen"
                element={<LoginPage />}
              />

              <Route
                path="account-activeren"
                element={<AccountActivationPage />}
              />

              <Route
                path="beheer"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="beheer/aanmeldingen"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminDogApplicationsPage />
                  </ProtectedRoute>
                }
              />
<Route
  path="beheer/honden"
  element={
    <ProtectedRoute requiredRole="admin">
      <AdminDogsPage />
    </ProtectedRoute>
  }
/>

              <Route
                path="beheer/agenda"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminAgendaPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="beheer/klanten"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminCustomersPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="mijn-pippaya"
                element={
                  <ProtectedRoute requiredRole="customer">
                    <CustomerPortalPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="mijn-pippaya/reserveren"
                element={
                  <ProtectedRoute requiredRole="customer">
                    <NewReservationPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="mijn-pippaya/reserveringen"
                element={
                  <ProtectedRoute requiredRole="customer">
                    <MyReservationsPage />
                  </ProtectedRoute>
                }
              />
<Route
  path="mijn-pippaya/beoordeling"
  element={
    <ProtectedRoute requiredRole="customer">
      <ReviewPage />
    </ProtectedRoute>
  }
/>

              <Route
                path="mijn-pippaya/honden"
                element={
                  <ProtectedRoute requiredRole="customer">
                    <MyDogsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="mijn-pippaya/hond-aanmelden"
                element={
                  <ProtectedRoute requiredRole="customer">
                    <NewDogApplicationPage />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>

          <BookingDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
          />
        </Router>
      </Box>
    </MuiThemeProvider>
  );
};

function App() {
  useEffect(() => {
    emailjs.init(
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY!
    );
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <ThemedApp />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;